import { ModuleWithProviders, NgModule } from '@angular/core';

import { HelpInfoService } from '@priva/appshell';
import { PrivaUtilitiesModule } from '@priva/utilities';

import { AppHelpInfoService } from './help.service';

@NgModule({
    imports: [PrivaUtilitiesModule],
    declarations: [],
    providers: [],
    exports: [],
})
export class HelpInfoModule {
    static forRoot(): ModuleWithProviders<HelpInfoModule> {
        return {
            ngModule: HelpInfoModule,
            providers: [{ provide: HelpInfoService, useClass: AppHelpInfoService }],
        };
    }
}
